import { UmbracoTypes } from '~/lib/data-contract';
import { usePage } from '~/services/umbraco/hooks';
import DynamicBlocks from '~/templates/blocks';

export default function P60ModulePage() {
    const { data: page } = usePage<UmbracoTypes.IP60ModulePage>();

    return <DynamicBlocks elements={page?.pageElements as UmbracoTypes.IModules[]} />;
}
